import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import SideBar from "../components/SideBar";
import { Typography, CircularProgress, TextField, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";

export default function AllUsers() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSideBarOpen, setIsSideBarOpen] = useState(true);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(users);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "shipments.xlsx");
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const response = await axios.post(
        `https://anydev.com-eg.net/api/CustomerService/V1/GetRequestData`,
        {
          fromDate: fromDate ? new Date(fromDate).toISOString() : null,
          toDate: toDate ? new Date(toDate).toISOString() : null,
          pageParam: {
            pageSize: 1000,
            pageNumber: 1,
          },
          requestTypeID: 0,
          statusID: 0,
          reasonID: 0,
        },
        {
          headers: {
            CompanyID: "212606",
            AccessToken: userData.data.accessToken,
            "Content-Type": "application/json",
            Language: "ar",
          },
        }
      );

      if (response.data.data && Array.isArray(response.data.data)) {
        const formattedUsers = response.data.data.map((user, index) => ({
          ...user,
          id: user.requestId || index,
        }));
        setUsers(formattedUsers);
      } else {
        console.error("No data found in response.");
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      if (error.response && error.response.status === 401) {
        console.log("Session expired, logging out...");
        localStorage.removeItem("userData");
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "requestId", headerName: t("request Id"), width: 90 },
    { field: "transDate", headerName: t("trans Date"), width: 150 },
    { field: "senderName", headerName: t("client Name"), width: 150 },
    { field: "requestSubTypeName", headerName: t("request Name"), width: 150 },
    { field: "walletNumber", headerName: t("wallet Number"), width: 150 },
    { field: "bankName", headerName: t("bank Name"), width: 150 },
    { field: "bankAccount", headerName: t("bank Account"), width: 150 },
    { field: "swiftCode", headerName: t("swift Code"), width: 150 },
    { field: "accountHolder", headerName: t("account Holder"), width: 150 },
    { field: "clientAddress", headerName: t("client Address"), width: 150 },
    { field: "clientPhone", headerName: t("client Phone"), width: 150 },
    { field: "clientName", headerName: t("clien tName"), width: 150 },
    { field: "numberOfAwbs", headerName: t("number Of Awbs"), width: 150 },
    { field: "pickupDate", headerName: t("pickup Date"), width: 150 },
    { field: "employeeName", headerName: t("employee Name"), width: 150 },
    { field: "courierName", headerName: t("courier Name"), width: 150 },
    { field: "courierPhone", headerName: t("courier Phone"), width: 150 },
    { field: "notes", headerName: t("notes"), width: 150 },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <SideBar
        open={isSideBarOpen}
        toggleOpen={() => setIsSideBarOpen(!isSideBarOpen)}
      />
      <Box
        sx={{
          height: "calc(100vh - 200px)",
          width: "93%",
          marginTop: "70px",
          marginLeft: isSideBarOpen ? "5px" : "250px",
          transition: "margin-left 0.3s",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginBottom: "20px",
            fontWeight: "bold",
            color: "#df1919ff",
            marginRight: "10px",
          }}
        >
          {t("allUser")}
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <TextField
            label="من التاريخ"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="إلى التاريخ"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <Button variant="contained" onClick={fetchUsers}>
            عرض البيانات
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={exportToExcel}
          >
            {t("Export to Excel")}
          </Button>
        </Box>

        {loading ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={users}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            disableRowSelectionOnClick
            sx={{
              // marginRight: "10px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "red",
                color: "#63729A",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#c71818ff",
                color: "white",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "#e0e0e0",
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
}
